import React, { useEffect, useState } from 'react';
import axios from 'axios';
import logo from '../resources/isylogo.png';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Header.css';
import LoadingPage from './LoadingPage';
import ErrorPage from './ErrorPage';

const Header = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();

    // Check if the user is an admin
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/user/me`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
                    }
                });
                setUser(response.data);
                setLoading(false);
            } catch (err) {
                if(err.response.status === 401) {
                    navigate('/login');
                } else {
                    setError(err);
                }
                setLoading(false);
            }
        };

        fetchUser();
    }, [API_URL, navigate]);

    if (loading) return <LoadingPage />;
    if (error) return <ErrorPage />;

    return (
        <header className="home-header">
            <Link to="/home">
                <img src={logo} alt="ISY Logo" className="home-logo" />
            </Link>
            <nav className="home-nav">
                <Link to="/">Home</Link>
                <Link to="/view-tools">View Tools</Link> 
                <Link to="/view-students">View Students</Link>
                {user?.is_admin && <Link to="/edit-students">Edit Records</Link>}
                <Link to="/my-account">My Account</Link>
            </nav>
        </header>
    );
};

export default Header;